import React, { Fragment, useState } from 'react';
import { useHistory, useRouteMatch } from 'react-router-dom';
import { NetworkStatus } from '@apollo/client';
import { useTranslation } from 'react-i18next';

import { GQLParty } from '@jewelutions/core-crm-server-api-client-domain';

import { userLanguage } from '../../../../core/AuthContext';
import { JwlTable, Chip, LoadingSpinner, ErrorComponent } from '../../../../components';

import { GQLOperationBuilder } from '../../../../operations/GQLOperationBuilder';
import { ProducerNavigation } from '../../navigation/ProducerNavigation';

interface IProps {
  party: GQLParty;
}

const AccessoriesList: React.FC<IProps> = ({ party }: IProps) => {
  const history = useHistory();
  const [errorComponentState, setErrorComponentState] = useState(false);
  const { t: translate } = useTranslation();

  const {
    data: accessoriesData,
    loading: accessoriesLoading,
    error: accessoriesError,
    refetch: refetchAccessories,
    networkStatus: accessoriesNetworkStatus
  } = GQLOperationBuilder.accessory.getAccessoriesByProducer({ producerPartyId: party.id });

  if (accessoriesLoading || accessoriesNetworkStatus === NetworkStatus.refetch) return <LoadingSpinner />;

  if (accessoriesError && !errorComponentState)
    return (
      <ErrorComponent
        close={setErrorComponentState}
        details={accessoriesError?.stack}
        callback={refetchAccessories}
        message={accessoriesError.message}
      />
    );

  const columns = ['Title', 'Description'];

  const getAccessoriesRows = () => {
    return GQLOperationBuilder.accessory.accessoryAssetArrayFromResponse(accessoriesData).map(accessory => {
      return {
        id: accessory.id,
        cells: [accessory.accessory.title[userLanguage], accessory.accessory.description[userLanguage]]
      };
    });
  };

  const navigateToAccessoryDetails = (accessoryId: string) => {
    history.push(ProducerNavigation.accessoryDetails.pathFromParams({ accessoryId: accessoryId }));
  };

  return (
    <Fragment>
      <JwlTable
        title="Producer accessories list"
        description={`The list of accessory geometries available to the producer ${party.name}`}
        columns={columns}
        rows={getAccessoriesRows()}
        onTableRowClick={navigateToAccessoryDetails}
      />
    </Fragment>
  );
};

export default AccessoriesList;
